/* eslint-disable react/prop-types */
import { MapContainer } from 'react-leaflet';
import ReactLeafletGoogleLayer from 'react-leaflet-google-layer';
import { useMemo } from 'react';
import { googleMapsApi } from '../../api';

export const GoogleMap = ({ children, setMap, width }) => {
  const center = useMemo(() => ({ lat: 23.512, lng: 80.329 }), []);

  const bounds = useMemo(
    () => [
      [center.lat, center.lng],
      [center.lat, center.lng]
    ],
    [center]
  );

  // Generate a unique key so React remounts the MapContainer
  const mapKey = `${center.lat}-${center.lng}`;

  return (
      <MapContainer
        style={{ height: '100%', width: '100%' }}
        zoom={16}
        center={center}
        bounds={bounds}
        whenReady={setMap}
      >
        <ReactLeafletGoogleLayer
          googleMapsLoaderConf={{
            apiKey: googleMapsApi,
            libraries: ['places']
          }}
          type="hybrid"
        />
        {children}
      </MapContainer>
  );
};
